
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hydSe", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


const $bb63054715080228$export$e1b8a1ae03e64401 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9_LXb",
    name: "ContextualCreateContentPopoverLoader",
    loader: async ()=>(await (parcelRequire("7HTXC"))).ContextualCreateContentPopover
});
const $bb63054715080228$export$1546232e68d28255 = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { spaceKey: spaceKey, source: source } = t0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    let t1;
    if ($[0] !== source || $[1] !== spaceKey) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bb63054715080228$export$e1b8a1ae03e64401, {
            spaceKey: spaceKey,
            source: source,
            isTreeItem: true,
            shouldRenderToParent: true
        });
        $[0] = source;
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== ssrPlaceholderIdProp || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "page-tree-create-button",
            "data-vc": "page-tree-create-button",
            ...ssrPlaceholderIdProp
        }, t1);
        $[3] = ssrPlaceholderIdProp;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
module.exports["ContextualCreateContentPopoverLoader"] = $bb63054715080228$export$e1b8a1ae03e64401;
module.exports["TreeBottomCreateButton"] = $bb63054715080228$export$1546232e68d28255;

});

parcelRegister("7HTXC", function(module, exports) {

let $59c7f52ef691ae89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $59c7f52ef691ae89$var$load("5Mm1x"),
    $59c7f52ef691ae89$var$load("gEkwn"),
    $59c7f52ef691ae89$var$load("4fYzp"),
    $59c7f52ef691ae89$var$load("cUs4j"),
    $59c7f52ef691ae89$var$load("excC5"),
    $59c7f52ef691ae89$var$load("6wr18"),
    $59c7f52ef691ae89$var$load("ffEVr"),
    $59c7f52ef691ae89$var$load("7EorR"),
    $59c7f52ef691ae89$var$load("hhss7"),
    $59c7f52ef691ae89$var$load("9F7vX")
]).then(()=>parcelRequire('k9zbN'));

});


//# sourceMappingURL=TreeBottomCreateButton.84f58c8b.js.map
